import React, { useEffect } from 'react';
import { Collapse, Divider, List, ListItem, ListItemText } from '@material-ui/core';
import { Trans } from 'react-i18next';
import i18next from 'i18next';
import { getCurrentPath, isDefaultRoute, isEmptyList, isEmptyPath } from '../SideNavigationMenuItemsHelper';
import { useSideNavigationSubMenuItemsStyles } from './SideNavigationMenuSubItems.styles';
import { ASSETS_PATH } from '../../../../../constants/endpoints';
import { ISideNavigationMenuItemsConfig } from '../../SideNavigationMenuConfiguration';

export interface ISideNavigationMenuSubItemsProps {
    items: ISideNavigationMenuItemsConfig[];
    selectedSubMenu: ISideNavigationMenuItemsConfig | null;
    isOpened: boolean;
    onClick: (item: ISideNavigationMenuItemsConfig) => void;
}

export const SideNavigationMenuSubItems = ({
    items,
    selectedSubMenu,
    onClick,
    isOpened,
}: ISideNavigationMenuSubItemsProps) => {
    const classes = useSideNavigationSubMenuItemsStyles();
    const iconBasePath = `${ASSETS_PATH}/img/menu/`;

    useEffect(() => {
        items.forEach((item) => {
            if (isDefaultRoute(item, selectedSubMenu)) {
                onClick(item);
                const path = getCurrentPath();
                const isInvalid = item && isEmptyList(item.subItems) && isEmptyPath(path);

                if (isInvalid) {
                    window.location.href = item.link;
                }
            }
        });
    }, [items, selectedSubMenu]);

    return (
        <Collapse in={isOpened} timeout="auto" unmountOnExit>
            <List className={classes.subMenuList} component="div" disablePadding>
                {items.map((item: ISideNavigationMenuItemsConfig, index: number) => {
                    const isSelected = selectedSubMenu === item;

                    return (
                        <div key={`${item.link}__sub-menu`}>
                            {item.withDivider && <Divider className={classes.divider} />}
                            <a href={item.link} className={classes.link}>
                                <ListItem
                                    button
                                    classes={{
                                        root: item.bullet ? classes.subMenuListItemWithBullet : classes.subMenuListItem,
                                        selected: classes.subMenuListItemSelected,
                                    }}
                                    disableRipple={true}
                                    onClick={() => onClick(item)}
                                    selected={isSelected}
                                >
                                    {item.bullet && (
                                        <img className={classes.bullet} src={`${iconBasePath}${item.bullet}.svg`} />
                                    )}

                                    <ListItemText
                                        primaryTypographyProps={{
                                            variant: 'body2',
                                        }}
                                        classes={{
                                            primary: isSelected
                                                ? classes.subMenuListItemContentSelected
                                                : classes.subMenuListItemContent,
                                        }}
                                    >
                                        <Trans>{i18next.t(item.name)}</Trans>
                                    </ListItemText>
                                </ListItem>
                            </a>
                        </div>
                    );
                })}
            </List>
        </Collapse>
    );
};
